import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import SOP_Form from "./sop_Form/SOP_Form";
import SOP_table from "./sop_table/SOP_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/structural_requirement/management_data/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function SOP() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const management_data = useSelector((state) => state.management_data);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        management_data_id: 4,
        page,
        per_page: management_data.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);
                    
  const haveReadPermission = permissions?.includes(FixIDS.sop.List);
  const haveAddPermission = permissions?.includes(FixIDS.sop.Add);

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="SOP" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              IS Standards are guidelines set by the Bureau of Indian Standards
              (BIS) to maintain uniformity, quality, and reliability in testing
              and production. The laboratory adheres to applicable IS standards
              to ensure accurate results, meet regulatory requirements, and
              uphold national and customer quality expectations.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          { haveAddPermission && <SOP_Form fetchCustomers={fetchCustomers} />}
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <SOP_table
            data={management_data}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            fetchCustomers={fetchCustomers}
          /> }
        </div>

        {/* <div className="m-3">
          <div className="add_another_holder">
            <div>
              <span>
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
}

export default SOP;
